import React from 'react';
import connect from "react-redux/es/connect/connect";
import {checkAuth} from "../../redux/auth/client/actions";

class RoutesComponent extends React.Component {

    componentWillMount() {
        const {checkAuth} = this.props;
        checkAuth();
    }

    render() {
        return null;
    }
}

const mapStateToProps = state => ({
    client: state.client,
});

const connected = connect(mapStateToProps, {
    checkAuth,
})(RoutesComponent);

export default connected;